import React from 'react';
import DateRangePicker from 'react-daterange-picker';
import "react-daterange-picker/dist/css/react-calendar.css";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import {} from 'moment/locale/fr';
import Reservation from './Reservation';
//import * as data from './data.json';




const moment = extendMoment(Moment);
moment.locale('fr');

const stateDefinitions = {
    available: {
      color: null,
      label: 'Disponible',
    },
   unavailable: {
      selectable: false,
      color: '#78818b',
      label: 'Indisponible',
    },
  };

  
   const unavailableDates=[
    ["12/07/2025","19/07/2025"],
    ["13/06/2026","27/06/2026"],
    ["01/08/2026","15/08/2026"],
    ["20/09/2026","30/12/2050"],

  ];

   const dateRanges = unavailableDates.map(r => {
     return {
       state: 'unavailable',
       range: moment.range(
        moment(r[0], 'DD/MM/YYYY'), moment(r[1], 'DD/MM/YYYY')
       ),
     };
      
   });

    

class Calendrier extends React.Component {
    constructor(props, context) {
      super(props, context);
  
      this.state = {
        isOpen: false,
        value: null
      };
    }

  // componentDidMount() {
  //    fetch('data.json', {
  //          method: 'get',
  //      })
  //      .then(response => {
  //        if (response.ok) {
  //          return response.json();
  //        } else {
  //          throw new Error('Request error');
  //        }
  //      })
  //      .then(data => this.setState({ dates: data.reservations.map( r => {
  //        return {
  //          state: 'unavailable',
  //          range: moment.range(moment(r[0], 'DD/MM/YYYY'), moment(r[1], 'DD/MM/YYYY'))
  //        };
  //      }) 
  //      }))
  //      .catch(error => this.setState({ error: error}));

  //   }

  
    onSelect = (value, states) => {
      this.setState({ value, states });
    };
  
    onToggle = () => {
      this.setState({ isOpen: !this.state.isOpen });
    };
  
    renderSelectionValue = () => {
        if (this.state.value){ return (
          <React.Fragment>
            <p>Séjour du
                {" "}
                {this.state.value.start.format("DD/MM/YYYY")}
                {" au "}
                {this.state.value.end.format("DD/MM/YYYY")}
            </p>
            </React.Fragment>
      )}else {return <React.Fragment><p> Sélectionner vos dates</p></React.Fragment>}
    };
  
    render() {
      return (
        <div>
            <h2>Disponibilité</h2>
          <DateRangePicker
              value={this.state.value}
              onSelect={this.onSelect}
              singleDateRange={true}
              firstOfWeek={1}
              locale={moment.locale()}

              numberOfCalendars={2}
              selectionType='range'
              minimumDate={new Date()}
              stateDefinitions={stateDefinitions}
              dateStates={dateRanges}
              defaultState="available"
              showLegend={true}
              selectedLabel='Votre sélection'
            />
            <div>{this.renderSelectionValue()}</div>
            <Reservation dates={this.state.value}/>
            
        </div>
        
      );
    }
  }

  export default Calendrier;



// WEBPACK FOOTER //
// ./src/Calendrier.js